/**
 * Size confirmation modal – intercepts Add to cart and Buy it now,
 * shows modal to confirm variant (size) before proceeding.
 */
(function () {
  const modalId = 'SizeConfirmationModal';
  let pendingAction = null; // 'add_to_cart' | 'buy_now'

  function getModal(sectionId) {
    return sectionId ? document.getElementById(`${modalId}-${sectionId}`) : null;
  }

  function getProductForm() {
    return document.querySelector('product-form');
  }

  function init() {
    const productForm = getProductForm();
    if (!productForm) return;

    const form = productForm.querySelector('form');
    const sectionId =
      form.closest('[data-section]')?.dataset?.section ||
      (form.id && form.id.startsWith('product-form-') ? form.id.replace('product-form-', '') : null);
    const modal = getModal(sectionId);

    function getQuantityInput() {
      return document.querySelector('input[name="quantity"][form="' + form.id + '"]') || form.querySelector('input[name="quantity"]');
    }

    if (!modal) {
      var stickyAdd = document.querySelector('[data-sticky-add-to-cart]');
      var stickyBuy = document.querySelector('[data-sticky-buy-now]');
      if (stickyAdd) {
        stickyAdd.addEventListener('click', function () { form.submit(); });
      }
      if (stickyBuy) {
        stickyBuy.addEventListener('click', function () {
          var vid = (form.querySelector('input[name="id"]') || {}).value;
          if (!vid) return;
          var qtyEl = getQuantityInput();
          var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
          addToCartAndCheckout(vid, qty, true);
        });
      }
      return;
    }

    const variantIdInput = form.querySelector('input[name="id"]');
    const variantButtons = modal.querySelectorAll('[data-variant-id]');

    function highlightSelectedVariant() {
      const currentId = variantIdInput && variantIdInput.value;
      variantButtons.forEach((btn) => {
        btn.classList.toggle('is-selected', btn.dataset.variantId === currentId);
      });
    }

    var qtyDisplay = modal.querySelector('[data-size-confirmation-qty-value]');

    function getModalQuantity() {
      if (!qtyDisplay) return 1;
      var qtyInput = getQuantityInput();
      if (qtyInput) return parseInt(qtyInput.value, 10) || 1;
      return parseInt(qtyDisplay.textContent, 10) || 1;
    }

    function setModalQuantity(val) {
      val = Math.max(1, Math.floor(val));
      var qtyInput = getQuantityInput();
      if (qtyInput) {
        var max = qtyInput.getAttribute('max') ? parseInt(qtyInput.getAttribute('max'), 10) : null;
        if (max !== null && val > max) val = max;
        qtyInput.value = val;
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
      if (qtyDisplay) qtyDisplay.textContent = val;
    }

    function syncModalQuantity() {
      var qtyInput = getQuantityInput();
      if (!qtyDisplay) return;
      var val = 1;
      if (qtyInput) {
        val = parseInt(qtyInput.value, 10) || parseInt(qtyInput.getAttribute('min'), 10) || 1;
        var min = parseInt(qtyInput.getAttribute('min'), 10) || 1;
        var max = qtyInput.getAttribute('max') ? parseInt(qtyInput.getAttribute('max'), 10) : null;
        if (max !== null && val > max) val = max;
        if (val < min) val = min;
      }
      setModalQuantity(val);
    }

    // Quantity stepper in modal – works with or without page quantity input
    var qtyWrap = modal.querySelector('[data-size-confirmation-quantity]');
    if (qtyWrap && qtyDisplay) {
      var qtyMinus = modal.querySelector('[data-size-confirmation-qty-minus]');
      var qtyPlus = modal.querySelector('[data-size-confirmation-qty-plus]');
      if (qtyMinus) {
        qtyMinus.addEventListener('click', function () {
          var qtyInput = getQuantityInput();
          var min = qtyInput ? (parseInt(qtyInput.getAttribute('min'), 10) || 1) : 1;
          var step = qtyInput ? (parseInt(qtyInput.getAttribute('step'), 10) || 1) : 1;
          var val = getModalQuantity();
          setModalQuantity(Math.max(min, val - step));
        });
      }
      if (qtyPlus) {
        qtyPlus.addEventListener('click', function () {
          var qtyInput = getQuantityInput();
          var max = qtyInput && qtyInput.getAttribute('max') ? parseInt(qtyInput.getAttribute('max'), 10) : null;
          var step = qtyInput ? (parseInt(qtyInput.getAttribute('step'), 10) || 1) : 1;
          var val = getModalQuantity();
          val = val + step;
          if (max !== null && val > max) val = max;
          setModalQuantity(val);
        });
      }
    }

    // Intercept form submit (Add to cart) – use capture so we run first
    form.addEventListener(
      'submit',
      function (evt) {
        if (form.dataset.skipSizeConfirmation === 'true') {
          delete form.dataset.skipSizeConfirmation;
          return;
        }
        evt.preventDefault();
        evt.stopImmediatePropagation();
        pendingAction = 'add_to_cart';
        modal.show(form.querySelector('[type="submit"]'));
        highlightSelectedVariant();
        syncModalQuantity();
      },
      true
    );

    // Buy it now: add our button and hide Shopify dynamic checkout so all flows go through modal
    const buttonsWrapper = form.querySelector('.product-form__buttons');
    const shopifyPaymentButton = form.querySelector('.shopify-payment-button');
    if (buttonsWrapper && shopifyPaymentButton) {
      const buyNowBtn = document.createElement('button');
      buyNowBtn.type = 'button';
      buyNowBtn.className = 'button button--full-width button--primary size-confirmation-buy-now';
      buyNowBtn.textContent = 'Buy it now';
      buyNowBtn.addEventListener('click', function () {
        pendingAction = 'buy_now';
        modal.show(buyNowBtn);
        highlightSelectedVariant();
        syncModalQuantity();
      });
      shopifyPaymentButton.style.display = 'none';
      shopifyPaymentButton.insertAdjacentElement('beforebegin', buyNowBtn);
    }

    // Variant selected in modal – only update selection, no redirect or add to cart
    variantButtons.forEach((btn) => {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var variantId = btn.dataset.variantId;
        variantIdInput.value = variantId;
        variantButtons.forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
      });
    });

    // Size chart button – open the product popup modal (e.g. size guide page)
    var sizeChartBtn = modal.querySelector('[data-size-confirmation-size-chart]');
    if (sizeChartBtn) {
      sizeChartBtn.addEventListener('click', function () {
        var popupId = sizeChartBtn.getAttribute('data-size-chart-modal');
        if (!popupId) return;
        var popupModal = document.getElementById(popupId);
        if (popupModal && typeof popupModal.show === 'function') {
          popupModal.show(sizeChartBtn);
        }
      });
    }

    function getSelectedVariantAndQuantity() {
      var selectedId = variantIdInput && variantIdInput.value;
      var selectedBtn = modal.querySelector('.size-confirmation-modal__variant-btn.is-selected');
      if (selectedBtn) selectedId = selectedBtn.dataset.variantId;
      var quantity = getModalQuantity();
      return { variantId: selectedId, quantity: quantity };
    }

    function setModalLoading(show) {
      var loadingEl = modal.querySelector('[data-size-confirmation-loading]');
      var actions = modal.querySelectorAll('.size-confirmation-modal__actions button');
      if (loadingEl) loadingEl.setAttribute('aria-hidden', show ? 'false' : 'true');
      actions.forEach(function (btn) { btn.disabled = show; });
    }

    // Add to cart button – add selected variant/quantity, show progress, then close and refresh cart
    var addBtn = modal.querySelector('[data-size-confirmation-add]');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var sel = getSelectedVariantAndQuantity();
        if (!sel.variantId) return;
        setModalLoading(true);
        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        var formData = new FormData();
        formData.append('id', sel.variantId);
        formData.append('quantity', String(sel.quantity));
        if (cart && typeof cart.getSectionsToRender === 'function') {
          formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
          formData.append('sections_url', window.location.pathname);
        }
        var config = typeof fetchConfig !== 'undefined' ? fetchConfig('javascript') : { method: 'POST', headers: {} };
        config.headers = config.headers || {};
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;
        fetch(window.routes.cart_add_url, config)
          .then(function (res) { return res.json(); })
          .then(function (data) {
            setModalLoading(false);
            if (data.status) {
              if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartError) {
                window.publish(window.PUB_SUB_EVENTS.cartError, { source: 'size-confirmation', productVariantId: sel.variantId, errors: data.description, message: data.message });
              }
              return;
            }
            if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
              window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: sel.variantId, cartData: data });
            }
            if (cart && typeof cart.renderContents === 'function') {
              cart.setActiveElement && cart.setActiveElement(document.activeElement);
              cart.renderContents(data);
            }
            modal.hide();
            pendingAction = null;
          })
          .catch(function (e) {
            console.error(e);
            setModalLoading(false);
          });
      });
    }

    // BUY NOW button – show progress, then add and redirect to checkout
    var checkoutBtn = modal.querySelector('[data-size-confirmation-checkout]');
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function () {
        var sel = getSelectedVariantAndQuantity();
        if (!sel.variantId) return;
        setModalLoading(true);
        var isBuyNow = pendingAction === 'buy_now';
        addToCartAndCheckout(sel.variantId, sel.quantity, isBuyNow);
        pendingAction = null;
      });
    }

    // Sticky bottom bar – open modal same as main Add to cart / Buy now
    var submitBtn = form.querySelector('[type="submit"]');
    var buyNowBtn = form.querySelector('.size-confirmation-buy-now');
    var stickyAdd = document.querySelector('[data-sticky-add-to-cart]');
    var stickyBuy = document.querySelector('[data-sticky-buy-now]');
    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () {
        pendingAction = 'add_to_cart';
        modal.show(submitBtn);
        highlightSelectedVariant();
        syncModalQuantity();
      });
    }
    if (stickyBuy) {
      stickyBuy.addEventListener('click', function () {
        pendingAction = 'buy_now';
        modal.show(buyNowBtn || stickyBuy);
        highlightSelectedVariant();
        syncModalQuantity();
      });
    }
  }

  function addToCartAndCheckout(variantId, quantity, clearCartFirst) {
    var checkoutUrl = window.routes.checkout_url || (window.shopUrl ? window.shopUrl + '/checkout' : '/checkout');
    var cartAddUrl = window.routes.cart_add_url || (window.shopUrl ? window.shopUrl + '/cart/add' : '/cart/add');
    var cartClearUrl = window.routes.cart_clear_url || (window.shopUrl ? window.shopUrl + '/cart/clear' : '/cart/clear');

    var config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: new URLSearchParams({ id: variantId, quantity: String(quantity) }).toString(),
    };

    function doAddAndRedirect() {
      fetch(cartAddUrl, config)
      .then(function (res) {
        return res.text().then(function (text) {
          if (text.trim().startsWith('<')) {
            return { _html: true, status: res.status };
          }
          try {
            return JSON.parse(text);
          } catch (e) {
            return { _html: true, status: res.status };
          }
        });
      })
      .then(function (data) {
        if (data._html) {
          if (clearCartFirst) {
            var iframe = document.createElement('iframe');
            iframe.name = 'size-confirmation-clear-frame';
            iframe.style.display = 'none';
            document.body.appendChild(iframe);
            var clearForm = document.createElement('form');
            clearForm.method = 'POST';
            clearForm.action = cartClearUrl;
            clearForm.target = 'size-confirmation-clear-frame';
            document.body.appendChild(clearForm);
            clearForm.submit();
            setTimeout(function () {
              var addForm = document.createElement('form');
              addForm.method = 'POST';
              addForm.action = cartAddUrl;
              var idInput = document.createElement('input');
              idInput.name = 'id';
              idInput.value = variantId;
              addForm.appendChild(idInput);
              var qtyInput = document.createElement('input');
              qtyInput.name = 'quantity';
              qtyInput.value = String(quantity);
              addForm.appendChild(qtyInput);
              document.body.appendChild(addForm);
              addForm.submit();
            }, 600);
          } else {
            var form = document.createElement('form');
            form.method = 'POST';
            form.action = cartAddUrl;
            var idInput = document.createElement('input');
            idInput.name = 'id';
            idInput.value = variantId;
            form.appendChild(idInput);
            var qtyInput2 = document.createElement('input');
            qtyInput2.name = 'quantity';
            qtyInput2.value = String(quantity);
            form.appendChild(qtyInput2);
            document.body.appendChild(form);
            form.submit();
          }
          return;
        }
        if (data.status && data.status !== 200) {
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartError) {
            window.publish(window.PUB_SUB_EVENTS.cartError, {
              source: 'size-confirmation',
              productVariantId: variantId,
              errors: data.description || data.message,
              message: data.message,
            });
          }
          return;
        }
        window.location.href = checkoutUrl;
      })
      .catch(function (e) {
        console.error(e);
        if (clearCartFirst) {
          var iframe = document.createElement('iframe');
          iframe.name = 'size-confirmation-clear-frame';
          iframe.style.display = 'none';
          document.body.appendChild(iframe);
          var clearForm = document.createElement('form');
          clearForm.method = 'POST';
          clearForm.action = cartClearUrl;
          clearForm.target = 'size-confirmation-clear-frame';
          document.body.appendChild(clearForm);
          clearForm.submit();
          setTimeout(function () {
            var addForm = document.createElement('form');
            addForm.method = 'POST';
            addForm.action = cartAddUrl;
            var idInput = document.createElement('input');
            idInput.name = 'id';
            idInput.value = variantId;
            addForm.appendChild(idInput);
            var qtyInput = document.createElement('input');
            qtyInput.name = 'quantity';
            qtyInput.value = String(quantity);
            addForm.appendChild(qtyInput);
            document.body.appendChild(addForm);
            addForm.submit();
          }, 600);
        } else {
          var form = document.createElement('form');
          form.method = 'POST';
          form.action = cartAddUrl;
          var idInput = document.createElement('input');
          idInput.name = 'id';
          idInput.value = variantId;
          form.appendChild(idInput);
          var qtyInput = document.createElement('input');
          qtyInput.name = 'quantity';
          qtyInput.value = String(quantity);
          form.appendChild(qtyInput);
          document.body.appendChild(form);
          form.submit();
        }
      });
    }

    if (clearCartFirst) {
      fetch(cartClearUrl, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' } })
        .then(function (res) { return res.text(); })
        .then(function (text) {
          try {
            var d = text.trim().startsWith('<') ? {} : JSON.parse(text);
            if (d && d.status && d.status !== 200) return;
          } catch (e) {}
          doAddAndRedirect();
        })
        .catch(function () { doAddAndRedirect(); });
    } else {
      doAddAndRedirect();
    }
  }

  /** When returning from checkout (e.g. back button), dismiss loading and close modal */
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('.size-confirmation-modal[open]').forEach(function (modal) {
      var loading = modal.querySelector('[data-size-confirmation-loading]');
      if (loading) loading.setAttribute('aria-hidden', 'true');
      modal.querySelectorAll('.size-confirmation-modal__actions button').forEach(function (btn) {
        btn.disabled = false;
      });
      if (typeof modal.hide === 'function') modal.hide();
    });
  });

  /** Move sticky bar to body so it’s viewport-fixed on iOS (avoids cropping from transformed ancestors) */
  function moveStickyBarToBody() {
    var bar = document.querySelector('.sticky-product-bar');
    if (bar && bar.parentNode && bar.parentNode !== document.body) {
      document.body.appendChild(bar);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      moveStickyBarToBody();
    });
  } else {
    init();
    moveStickyBarToBody();
  }

  document.addEventListener('shopify:section:load', function () {
    init();
    moveStickyBarToBody();
  });
})();
